@if (!treeCategoryWithProduct().products.length) {
  <app-product-category-atom
    [heading]="treeCategoryWithProduct().category.name"
    [description]="treeCategoryWithProduct().category.description ?? ''"
    [id]="treeCategoryWithProduct().category.id"
  ></app-product-category-atom>
  @for (
    subTreeCategoryWithProduct of treeCategoryWithProduct().children;
    track subTreeCategoryWithProduct.category.id
  ) {
    <app-category-factory
      [componentClass]="componentClass()"
      [treeCategoryWithProduct]="subTreeCategoryWithProduct"
      [isOrderingAllowed]="isOrderingAllowed()"
      [categoryNameColor]="categoryNameColor()"
      [categoryDescriptionColor]="categoryDescriptionColor()"
      [highlightCategoryNameColor]="highlightCategoryNameColor()"
      [highlightCategoryBackgroundColor]="highlightCategoryBackgroundColor()"
      [productNameColor]="productNameColor()"
      [productDescriptionColor]="productDescriptionColor()"
      [productPriceColor]="productPriceColor()"
      [productImagePlaceholderColor]="productImagePlaceholderColor()"
      [productBorderColor]="productBorderColor()"
      [productBackgroundColor]="productBackgroundColor()"
      [tagColors]="tagColors()"
      (navigateTo)="navigateTo.emit($event)"
    ></app-category-factory>
  }
}
<ng-template appComponentHost></ng-template>
